export default __webpack_public_path__ + "static/media/ico-facebook.b397899f.svg";